import React from "react";

import "../Style/HeroSection.css";
import HomeCoverPhoto from "../assets/NewPhotos/HomeCoverPhoto.png";
import { useNavigate } from "react-router-dom";

function HeroSection() {
  const navigate = useNavigate();
  return (
    <section className="hero">
      <img
        className="hero-bg"
        src={HomeCoverPhoto}
        alt="Watercolor hot air balloon floating through soft clouds"
      />
      <div className="hero-overlay" />

      <div className="hero-content">
        <p className="hero-label">Inspired by</p>

        <h1 className="hero-title">Elevation</h1>

        <p className="hero-text">
          Handcrafted fragrance sculptures that transform light, scent, and
          atmosphere into meaningful spaces.
        </p>

        <div className="hero-buttons">
          <button
            className="hero-btn-primary"
            onClick={() =>
              navigate("/our-story", {
                state: { scrollToStoryRisePanel: true },
              })
            }
          >
            Manifesto
          </button>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
